import { formatMoney } from 'accounting'

import { Box, FormField, Text } from '@domain-group/suit-theme'

import useQuoteBuilder from '../../hooks/useQuoteBuilder'

interface PaymentDetailsFooterProps {
  campaignQuotePayload: ReturnType<typeof useQuoteBuilder>['campaignQuotePayload'],
}

const PaymentDetailsFooter = (props: PaymentDetailsFooterProps) => {
  const {
    campaignQuotePayload: {
      campaignQuote: {
        total,
      },
      paymentMethod,
      paymentMethodFee,
    },
  } = props

  return (
    <Box borderTop="1px solid" borderColor="lineColor" padding="large">
      <Box alignItems="center" width="auto">
        <FormField direction="column" label="Payment Method">
          {/*
           // @ts-expect-error TS2339 */}
          <Text fontSize="small">{paymentMethod.title || 'Not Selected'}</Text>
        </FormField>
      </Box>

      <Box alignItems="flex-end" flexDirection="column" justifyContent="center" marginLeft="auto" width="auto">
        <Text fontSize="medium">{formatMoney(total)}</Text>

        {paymentMethodFee && (
          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            + {formatMoney(paymentMethodFee)} Fees
          </Text>
        )}
      </Box>
    </Box>
  )
}

export default PaymentDetailsFooter
